
export const VIEW_MODE = "view";
export const EDIT_MODE = "edit";
export const CREATE_MODE = "create";
export const DELETE_MODE = "delete";


// WEBPACK FOOTER //
// ./src/components/constants.js